module.exports = __webpack_public_path__ + "img/page_paper_file_document_search_icon.33f380aa.svg";